// extracted by mini-css-extract-plugin
module.exports = {"inputFormContainer":"BasicInfo_inputFormContainer__3pt__","summary":"BasicInfo_summary__1GhhG","danger":"BasicInfo_danger__1yECI"};